
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import PlatformMarkerPlatLong from "../../editor/platform-markers/cave/PlatformMarkerPlatLong";
import PlatformMarkerStack3 from "../../editor/platform-markers/cave/PlatformMarkerStack3";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CaveStartChunk extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 367.8941131276538, y ?? 592.0721129292459);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -521.8941040039062, -136.07208251953125);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 336, -136);
    this.add(editor_bounds_right);

    // platformMarkerPlatLong
    const platformMarkerPlatLong = new PlatformMarkerPlatLong(scene, -204, -324);
    this.add(platformMarkerPlatLong);

    // platformMarkerStack3
    const platformMarkerStack3 = new PlatformMarkerStack3(scene, -464, -214);
    this.add(platformMarkerStack3);

    // platformMarkerStack
    const platformMarkerStack = new PlatformMarkerStack3(scene, 58, -214);
    this.add(platformMarkerStack);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -387, -370);
    this.add(checkpointMarker);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
